const FeaturedTextTranslation = ({ text }: { text: string | number }) => {
  return <span className=" font-medium text-emblue-primary">{text}</span>;
};

export default FeaturedTextTranslation;
